import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#projects", label: "Projects", testId: "nav-projects-link" },
  { href: "#about", label: "About", testId: "nav-about-link" },
  { href: "#completed", label: "Delivered", testId: "nav-completed-link" },
  { href: "#contact", label: "Contact", testId: "nav-contact-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
          <img src="/images/logo.webp" alt="Taha Developers" className="h-11 w-11 object-cover rounded-full border border-[#C5A059]/40" />
          <span className="font-display text-lg tracking-wide hidden sm:block">TAHA DEVELOPERS</span>
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              className="font-accent text-xs tracking-[0.2em] uppercase text-zinc-400 hover:text-[#C5A059] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-enquire-button"
            className="bg-[#C5A059] text-black font-accent text-xs tracking-[0.2em] uppercase px-6 py-3 hover:bg-[#D4AF37] hover:-translate-y-0.5 transition-all duration-300"
          >
            Enquire Now
          </a>
        </nav>
        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle" aria-label="Menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-${l.label.toLowerCase()}-link`}
              className="font-accent text-sm tracking-[0.2em] uppercase text-zinc-300 hover:text-[#C5A059] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}
